module.exports = __webpack_public_path__ + "img/11y.9d3c6296.png";